const secondsToMinutes = (seconds: number): string => {
    if (seconds < 60) {
        return seconds + ' sec';
    }

    return Math.floor(seconds / 60) + ' min';
};
export default secondsToMinutes;
